import request from '../request'

export function add(data) {
    return request({
        url: '/user-service/hr/employee/registration/add',
        method: 'post',
        data,
    })
}

export function fetchDetail({ id }) {
    return request({
        url: '/user-service/hr/employee/registration/detail' + id,
    })
}

export function edit(data) {
    return request({
        url: '/user-service/branchEmployee/modify',
        method: 'post',
        data,
    })
}

export function resubmit(data) {
    return request({
        url: '/user-service/hr/employee/registration/resubmit',
        method: 'post',
        data,
    })
}

